import {Component, Input, OnDestroy, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {FilesRepositoryService, Patient, TreatmentPlan} from '@xmedical/core';
import {PatientStore, PatientTreatmentPlansStore, PracticeStore} from '../../../../../core/state';
import {CoreService} from '../../../../../core/services/core.service';

@Component({
    selector: 'app-treatment-plan-widget',
    templateUrl: './treatment-plan-widget.component.html',
    styleUrls: ['./treatment-plan-widget.component.scss'],
    standalone: false
})
export class TreatmentPlanWidgetComponent implements OnDestroy {

  @Input() plan: TreatmentPlan;
  printing = false;
  private filesRepositorySubscription: Subscription;

  private patientStore = inject(PatientStore);
  private plansStore = inject(PatientTreatmentPlansStore);
  private practiceStore = inject(PracticeStore);
  private coreService = inject(CoreService);

  constructor(private filesRepository: FilesRepositoryService) { }

  ngOnDestroy() {
    if (this.filesRepositorySubscription) { this.filesRepositorySubscription.unsubscribe(); }
  }

  get patientId(): number {
    return this.patientStore.current()?.id ?? 0;
  }

  get patient(): Patient | null {
    return this.patientStore.current();
  }

  get confirmationMessage(): string {
    return 'Are you sure you wish to print this treatment plan?';
  }

  print(id: number) {
    this.printing = true;
    this.filesRepositorySubscription = this.filesRepository.getUrl('plan', id, this.patientId).subscribe({
      next: url => {
        window.open(url, '_blank');
        this.printing = false;
        // Server marks the plan as printed; refresh the list to pick up
        // the new printed timestamp. Documents follow-up will move this
        // into a dedicated DocumentsService that pings the relevant store.
        this.plansStore.reload();
      },
      error: error => {
        console.error(error);
        this.printing = false;
      }
    });
  }

  get canDelete(): boolean {
    if (!this.practiceStore.practiceSettings()?.deleteUnprintedClinicalItemsEnabled) return false;
    return !this.plan?.printed;
  }

  get deleteConfirmationMessage(): string {
    return 'Delete this treatment plan? This cannot be undone.';
  }

  delete(id: number): void {
    this.plansStore.delete(id).subscribe({
      error: () => this.coreService.showErrorToast('Could not delete this treatment plan')
    });
  }

}
